import apiFetch from '../apiFetch'

export default function (documentId, sheetId, token) {
  return apiFetch({ endPoint: `documentHistorical/${documentId}/sheet/${sheetId}`, method: 'DELETE', body: null, token: token })
}
